import * as _ from "lodash";
import { TalkingPoint } from "./talking-point.model";

export class TalkingPointCategory {
    public otpcid: any = null;
    public tpcid: any = null;
    public tpcname: any = null;
    public points: any = [];

    constructor(data?: any) {
        if (data) {
            this.setData(data);
        }
    }

    setData(data: any): void {
        for (let i = 0; i < data.points.length; i++) {
            data.points[i] = new TalkingPoint(data.points[i]);
        }
        _.merge(this, data);
        this.points = data.points;
    }
}
